
interface SearchTypes {
    generate(args);
    [type: string]: any;
}

export const searchTypes: SearchTypes = {
    generate: function (args) {
        args = args || {};

        if ($.type(args) == "string") {
            args = {
                entityType: args
            };
        }

        var entityType = args.entityType || "",
            screenEntityType = args.screenEntityType || "",
            searchOptions = args.searchOptions || null,
            columnOrder = args.columnOrder || null,
            columnRenames = args.columnRenames || {},
            filter = args.filter || "",
            sort = args.sort || null,
            height = args.height || null,
            columns = args.columns || null,
            utilityColumns = args.utilityColumns || null,
            expand = args.expand || null,
            id = args.id || null,
            title = args.title || args.entityType,
            select = args.select || null,
            additionalSearchOptions = args.additionalSearchOptions || [],
            additionalColumnsOrders = args.additionalColumnsOrders || [],
            additionalColumnsRenames = args.additionalColumnsRenames || {},
            additionalExpand = args.additionalExpand || "",
            additionalSelect = args.additionalSelect || "",
            additionalColumns = args.additionalColumns || [],
            dataSource = args.dataSource || undefined,
            change = args.change || undefined,
            dataBound = args.dataBound || undefined,
            url = args.url || null,
            macroLocation = args.macroLocation || null,
            showSearchPopUp = args.showSearchPopUp,
            stickyDefaultName = args.stickyDefaultName;

        var type = searchTypes[entityType];

        if (type) {

            if (type.entityType && type.entityType != args.entityType) {
                entityType = type.entityType;
            }

            if (!macroLocation) {
                macroLocation = type.macroLocation;
            }

            if (!searchOptions && type.searchOptions) {
                searchOptions = type.searchOptions.concat(additionalSearchOptions);
            }

            if (!columnOrder && type.columnOrder) {
                columnOrder = type.columnOrder.concat(additionalColumnsOrders);
            }

            $.extend(columnRenames, additionalColumnsRenames);
            $.extend(columnRenames, (type.columnRenames || {}));

            if (!expand) {
                var typeExpand = type.expand
                    ? type.expand.split(",")
                    : [];
                typeExpand = $.map(typeExpand, $.trim);

                if (additionalExpand) {
                    var extraExpands = $.map(additionalExpand.split(","), $.trim);
                    typeExpand = typeExpand.concat(extraExpands).getUnique();
                }

                expand = typeExpand.join(",");
            }

            if (!select) {
                var typeSelect = type.select ? type.select.split(",") : [];
                typeSelect = $.map(typeSelect, $.trim);

                if (type.columnOrder) {
                    $.each(type.columnOrder, function (index, columnInColumnOrder) {
                        typeSelect.push(columnInColumnOrder.replaceAll(".", "/"));
                    });
                }

                if (additionalSelect) {
                    var extraSelects = $.map(additionalSelect.split(","), $.trim);
                    typeSelect = typeSelect.concat(extraSelects).getUnique();
                }

                select = typeSelect.join(",");
            }

            if (!id) {
                id = type.id;
            }

            if (type.title && !args.title) {
                title = type.title;
            }

            if (!filter) {
                filter = type.filter;
            }

            if (!columns && type.columns) {
                columns = type.columns.concat(additionalColumns);
            }

            if (!sort) {
                sort = type.sort;
            }

            if (!url) {
                url = type.url;
            }

            if (!height) {
                height = type.height;
            }

            if (!dataSource) {
                dataSource = type.dataSource;
            }

            if (!dataBound) {
                dataBound = type.dataBound;
            }

            if (!change) {
                change = type.change;
            }

            screenEntityType = screenEntityType || type.screenEntityType;

            args.codeColumnsToIgnore = type.codeColumnsToIgnore
                ? type.codeColumnsToIgnore
                : [];
            args.divisionsAndRegionsAndMyStuff = type.divisionsAndRegionsAndMyStuff;
            args.divisions = args.divisions == undefined
                ? type.divisions
                : args.divisions;
            args.regions = args.regions == undefined
                ? type.regions
                : args.regions;
            args.regionNotRequired = args.regionNotRequired == undefined
                ? type.regionNotRequired
                : args.regionNotRequired;
            args.divisionsNavigationTypes = type.divisionsNavigationTypes == null
                ? ""
                : type.divisionsNavigationTypes;
            args.regionsNavigationTypes = type.regionsNavigationTypes == null
                ? ""
                : type.regionsNavigationTypes;
            args.divisionAndRegionOnly = args.divisionAndRegionOnly == undefined
                ? type.divisionAndRegionOnly
                : args.divisionAndRegionOnly;
            args.divisionsFilterOverride = args.divisionsFilterOverride == undefined
                ? type.divisionsFilterOverride
                : args.divisionsFilterOverride;
            args.regionsFilterOverride = args.regionsFilterOverride == undefined
                ? type.regionsFilterOverride
                : args.regionsFilterOverride;
            args.defaultDivisionSearchOption = args.defaultDivisionSearchOption == undefined
                ? type.defaultDivisionSearchOption
                : args.defaultDivisionSearchOption;
            args.defaultRegionSearchOption = args.defaultRegionSearchOption == undefined
                ? type.defaultRegionSearchOption
                : args.defaultRegionSearchOption;
            args.divisionDefaultValue = type.divisionDefaultValue
                ? type.divisionDefaultValue
                : args.divisionDefaultValue;
            args.additionalDisplayFields = args.additionalDisplayFields || type.additionalDisplayFields;
        }

        return {
            entityType: entityType,
            screenEntityType: screenEntityType,
            searchOptions: searchOptions,
            columnOrder: columnOrder,
            columnRenames: columnRenames,
            dataSource: dataSource,
            dataBound: dataBound,
            macroLocation: macroLocation,
            change: change,
            expand: expand,
            select: select,
            url: url,
            urlPostfix: args.urlPostfix,
            id: id,
            title: title,
            filter: filter,
            columns: columns,
            utilityColumns: utilityColumns,
            sort: sort,
            height: height,
            showSearchPopUp: showSearchPopUp,
            divisionsAndRegionsAndMyStuff: args.divisionsAndRegionsAndMyStuff,
            divisions: args.divisions,
            regions: args.regions,
            regionNotRequired: args.regionNotRequired,
            divisionsNavigationTypes: args.divisionsNavigationTypes,
            regionsNavigationTypes: args.regionsNavigationTypes,
            divisionAndRegionOnly: args.divisionAndRegionOnly,
            divisionsFilterOverride: args.divisionsFilterOverride,
            regionsFilterOverride: args.regionsFilterOverride,
            defaultDivisionSearchOption: args.defaultDivisionSearchOption,
            defaultRegionSearchOption: args.defaultRegionSearchOption,
            codeColumnsToIgnore: args.codeColumnsToIgnore,
            divisionDefaultValue: args.divisionDefaultValue,
            additionalDisplayFields: args.additionalDisplayFields,
            stickyDefaultName: stickyDefaultName
        };
    }
};
